import { render, staticRenderFns } from "./EditOfferBeneficiaryModal.vue?vue&type=template&id=751b32c2"
import script from "./EditOfferBeneficiaryModal.vue?vue&type=script&lang=js"
export * from "./EditOfferBeneficiaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports